import * as React from 'react';
import { Box } from '@locus-taxy/neo-ui';

const LoginBackground = props => {
    return (
        <Box
            height="100%"
            width="100%"
            padding={5}
            sx={{
                backgroundImage: `url(${props.image})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100%',
                backgroundPositionY: 'bottom',
                backgroundPositionX: 'right'
            }}
        >
            {props.children}
        </Box>
    );
};
export default LoginBackground;
